// styles/GlobalStyle.js
import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    font-size: ${({ theme }) => theme.fontSizes.md};
    line-height: ${({ theme }) => theme.lineHeights.normal};
    scroll-behavior: smooth;
  }


  *, *::before, *::after {
    box-sizing: inherit;
  }

  body {
    overflow-x: hidden;
    margin: 0;
    padding: 0;
    width: 100%;
    font-family: ${({ theme }) => theme.fonts.body};
    color: ${({ theme }) => theme.colors.text};
    // background-color: ${({ theme }) => theme.colors.background};
    background-color: #0e1320;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    ${({ theme }) =>
      process.env.NODE_ENV === 'production' &&
      `
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
      `}
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
    font-weight: ${({ theme }) => theme.fontWeights.semibold};
    text-decoration-thickness: 1.5px;
    text-underline-offset: 2px;
    transition: ${({ theme }) => theme.transition.fast};

    &:hover,
    &:focus {
      color: ${({ theme }) => theme.colors.primaryHover};
      text-decoration: none;
      outline: none;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    line-height: ${({ theme }) => theme.lineHeights.heading};
    margin: 0 0 ${({ theme }) => theme.spacing.md} 0;
  }

  p {
    margin: 0 0 ${({ theme }) => theme.spacing.md} 0;
    max-width: 680px;

    ${({ theme }) => theme.mq.mobile} {
      max-width: 100%;
    }
  }

  code {
    font-family: ${({ theme }) => theme.fonts.mono};
    font-size: ${({ theme }) => theme.fontSizes.sm};
    background-color: ${({ theme }) => theme.colors.codeBg};
    color: ${({ theme }) => theme.colors.codeText};
    padding: 0.2em 0.4em;
    border-radius: ${({ theme }) => theme.borderRadius.sm};
  }

  #notification-wrapper {
    position: fixed !important;
    z-index: 50000 !important;
  }

  .toast-notification{
    width: 100% !important;
    display: block !important;
  }


`;
